import React from "react";
import line from "../../assets/images/services/line.png";

const ServiceCard = ({ title, description, image, reverse, subtitle,id }) => {
  return (
    <div
      className={`flex flex-col md:flex-row  justify-center gap-20 items-stretch relative ${
        reverse ? "md:flex-row-reverse" : ""
      }`}
      id={id}
    >
      <div
        className="w-full flex  md:w-1/2 bg-white p-5 shadow-xl"
        style={{
          boxShadow:
            "0 4px 6px -1px rgba(0,0,0,0.1), 0 -4px 6px -1px rgba(0,0,0,0.1), 4px 0 6px -1px rgba(0,0,0,0.1), -4px 0 6px -1px rgba(0,0,0,0.1)",
        }}
      >
        <img
          src={image}
          alt={title}
          className={`${
            reverse
              ? "rounded-tr-[6rem] rounded-bl-[6rem]"
              : "rounded-br-[6rem] rounded-tl-[6rem]"
          }   shadow-md object-cover m-auto`}
        />
      </div>
      <img
        src={line}
        alt="line"
        className={`absolute top-1/2 -z-10 w-20 hidden md:block ${
          reverse ? "scale-y-[-1]" : ""
        }`}
      />
      <div
        className="w-full md:w-1/2 bg-white rounded-xl shadow-md p-6"
        style={{
          boxShadow:
            "0 4px 6px -1px rgba(0,0,0,0.1), 0 -4px 6px -1px rgba(0,0,0,0.1), 4px 0 6px -1px rgba(0,0,0,0.1), -4px 0 6px -1px rgba(0,0,0,0.1)",
        }}
      >
        <h3 className="text-lg md:text-xl font-outfitSemiBold mb-4">{title}</h3>
        <h3 className="md:text-lg font-outfitRegular mb-4">{subtitle}</h3>
        <ul className="list-inside space-y-1 text-sm">
          {description.map((point, index) => (
            <li key={index} className="leading-relaxed">
              <span className="h-2 w-2 bg-primary-900 mt-1 mr-2 rounded-[1px] rotate-[30deg] shrink-0 inline-block"></span>
              {point}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ServiceCard;
